
module.exports = require('rangeslider-pure');

